import { Component } from '@angular/core';

@Component({
  selector: 'app-sale-icon',
  templateUrl: './sale-icon.component.html',
})
export class SaleIconComponent {

}
